import {ModuleWithProviders, NgModule, Optional, SkipSelf} from '@angular/core';

import {CommonModule} from '@angular/common';
import {NavigationService} from './navigation.service';
import {CryptoService} from './crypto.service';
import {ProgressIndicatorService} from '../@shared';
import {StatePersistenceService} from './state.persistence.service';
import {LocalstorageService} from './localstorage.service';
import {SearchService} from './search.service';

@NgModule({
    imports:      [ CommonModule ],
    declarations: [ ],
    exports:      [ ]
})
export class ServiceModule {
    constructor(@Optional() @SkipSelf() parentModule?: ServiceModule) {
        if (parentModule) {
            throw new Error(
              'ServiceModule is already loaded. Import it in the AppModule only.');
        }
    }

    static forRoot(): ModuleWithProviders<ServiceModule> {
        return {
            ngModule: ServiceModule,
            providers: [
                CryptoService,
                NavigationService,
                ProgressIndicatorService,
                StatePersistenceService,
                SearchService,
                LocalstorageService
            ]
        };
    }
}
